var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"mb-0",class:_vm.cls,attrs:{"icon":_setup.compIcon,"outlined":_vm.outlined,"text":"","color":_setup.compColor}},[(_vm.title)?_c('div',{staticClass:"text-larger text-bold mb-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"text-regular"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }